module.exports = __webpack_public_path__ + "kr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/kr.svg
// module id = 646
// module chunks = 0